// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"112a4bf4","208":"a77b5847","631":"b6f0383a","653":"a0749ab7","828":"ec081b0a"}[chunkId] + ".chunk.js";
};